export default {"src":"https://app.iconosquare.com/_next/static/media/capterra-logo.6169259b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};